var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-menu"},[_c('menuItem',{attrs:{"fromPage":_vm.fromPage,"menuData":_vm.menuData,"navType":_vm.navType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }